export const obtenerCampo = (error) => {
  if (!error) return {};
  const [firstError] = error;
  const fieldName = firstError?.name?.[0];
  if (!fieldName) return {};
  return fieldName;
};

export const newScrollToErrorField = (errors, formRef) => {
  const fieldName = obtenerCampo(errors);
  if (fieldName) {
    formRef.scrollToField(fieldName, {
      behavior: 'smooth', // Opcional: define cómo se realiza el desplazamiento
      block: 'center' // Opcional: define cómo se centra el campo en la vista
    });
    return fieldName;
  }
  return [];
};

export const encontrarActiveKeyPorValor = (objeto, valorBuscado) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [campo, valores] of Object.entries(objeto)) {
    if (Array.isArray(valores) && valores.includes(valorBuscado)) {
      return campo;
    }
  }
  return null;
};
